import styled from "@emotion/styled";
import { ReactNode } from "react";
import { Typography, Button, buttonClasses } from "@kaltura/ds-react-components";

interface UploadDropButtonProps {
    text?: string;
    icon?: ReactNode;
    onClick: () => void;
}

const StyledContainer = styled(Button)(({ theme }) => ({
    height: "100%",
    width: "100%",
    paddingRight: theme.spacing(3),
    paddingLeft: theme.spacing(3),
    backgroundColor: theme.kaltura.palette.tone7,
    border: `1px solid ${theme.kaltura.palette.tone4}`,
    borderRadius: theme.kaltura.shape.roundness2,
    color: theme.kaltura.palette.tone1,
    svg: {
        color: theme.kaltura.palette.tone3,
        width: 40,
        height: 40,
    },
    "&:hover": {
        backgroundColor: theme.kaltura.palette.tone7,
        border: `1px solid ${theme.kaltura.palette.tone4}`,
    },
    [`& .${buttonClasses.label}`]: {
        height: "100%",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: 0,
    },
}));

/**
 * upload button + drag and drop
 */
export const UploadDropButton = (props: UploadDropButtonProps) => {
    const { text, icon, onClick } = props;

    return (
        <StyledContainer onClick={onClick}>
            {icon}
            <Typography variant="body2">{text}</Typography>
        </StyledContainer>
    );
};
